import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import {ReceiptPickingListState} from "@/interfaces/state";
import store from "@/store"
import {IdMapper} from "@/interfaces/state/base";
import {ReceiptExpensePickingList} from "@/interfaces/entity/receiptExpensePickingList";
import {PaginationMeta} from "@/interfaces/common";
import {ReceiptPickingListParams} from "@/modules/receiptsexpenses/receiptpickinglist/params";
import union from "lodash/union";
import {
    confirmReceiptCustomerPickingList, confirmReceiptEmployeePickingList,
    confirmReceiptPickingList,
    listReceiptPickingList
} from "@/modules/receiptsexpenses/receiptpickinglist/services";

@Module({ dynamic: true, name: "receiptPickingListStore", store })
class ReceiptPickingListModule extends VuexModule implements ReceiptPickingListState {
    data: IdMapper<ReceiptExpensePickingList> = {};
    ids: number[] = [];
    meta: PaginationMeta = new PaginationMeta();
    params: ReceiptPickingListParams = new ReceiptPickingListParams();

    @Mutation
    private MAP_RECEIPT_PICKING_LIST(payload: any) {
        const idMapper = {} as any;
        this.meta = payload.meta;
        this.ids = payload.datas?.map((data: ReceiptExpensePickingList, index: number) => {
            idMapper[data.id] = {...data, stt: index + 1};
            return data.id;
        });
        this.data = idMapper;
    }

    @Mutation
    private SET_RECEIPT_PICKING_LIST(payload: ReceiptExpensePickingList) {
        this.ids = union(this.ids, [payload.id]);
        this.data[payload.id] = payload;
    }

    @Mutation
    private DELETE_RECEIPT_PICKING_LIST(payload: ReceiptExpensePickingList) {
        this.ids = this.ids.filter((id: number) => payload.id !== id);
        delete this.data[payload.id];
    }

    @Mutation
    private UPDATE_RECEIPT_PICKING_LIST_PARAMS(payload: any) {
        this.params = payload;
    }

    @Mutation
    private SET_DEBTS_EMPLOYEE_INTO_RECEIPT_PICKING_LIST({ id, debts }) {
        if (this.data[id])
            this.data[id] = { ...this.data[id], debtEmployees: debts }
    }

    @Mutation
    private SET_DEBTS_PARTNER_INTO_RECEIPT_PICKING_LIST({ id, debts }) {
        if (this.data[id])
            this.data[id] = { ...this.data[id], debtEmployees: debts }
    }

    @Mutation
    private SET_DEBTS_POST_OFFICE_INTO_RECEIPT_PICKING_LIST({ id, debts }) {
        if (this.data[id])
            this.data[id] = { ...this.data[id], creditorPostOffices: debts }
    }

    @Mutation
    private SET_DEBTS_CUSTOMER_INTO_RECEIPT_PICKING_LIST({ id, debts }) {
        if (this.data[id])
            this.data[id] = { ...this.data[id], debtCustomers: debts }
    }

    @Action({ rawError: true })
    public async listReceiptPickingList(params: ReceiptPickingListParams) {
        const { data } = await listReceiptPickingList(params);
        this.MAP_RECEIPT_PICKING_LIST(data);
    }

    @Action({ rawError: true })
    public updateReceiptPickingListParams(payload: any) {
        this.UPDATE_RECEIPT_PICKING_LIST_PARAMS(payload);
    }

    @Action({ rawError: true })
    public setDebtsEmployeeIntoReceiptPickingList({ id, debts }) {
        this.SET_DEBTS_EMPLOYEE_INTO_RECEIPT_PICKING_LIST({ id, debts });
    }

    @Action({ rawError: true })
    public setDebtsPartnerIntoReceiptPickingList({ id, debts }) {
        this.SET_DEBTS_PARTNER_INTO_RECEIPT_PICKING_LIST({ id, debts });
    }

    @Action({ rawError: true })
    public setDebtsPostOfficeIntoReceiptPickingList({ id, debts }) {
        this.SET_DEBTS_POST_OFFICE_INTO_RECEIPT_PICKING_LIST({ id, debts });
    }

    @Action({ rawError: true })
    public setDebtsCustomerIntoReceiptPickingList({ id, debts }) {
        this.SET_DEBTS_CUSTOMER_INTO_RECEIPT_PICKING_LIST({ id, debts });
    }

    @Action({ rawError: true })
    public setReceiptPickingList(payload: any) {
        this.SET_RECEIPT_PICKING_LIST(payload);
    }

    @Action({ rawError: true })
    public async confirmPostOfficeReceiptPickingList(id: number) {
        const { data } = await confirmReceiptPickingList(id);
        this.SET_RECEIPT_PICKING_LIST(data.data);
    }

    @Action({ rawError: true })
    public async confirmEmployeeReceiptPickingList(id: number) {
        const { data } = await confirmReceiptEmployeePickingList(id);
        this.SET_RECEIPT_PICKING_LIST(data.data);
    }

    @Action({ rawError: true })
    public async confirmCustomerReceiptPickingList(id: number) {
        const { data } = await confirmReceiptCustomerPickingList(id);
        this.SET_RECEIPT_PICKING_LIST(data.data);
    }
}

export const ReceiptPickingListStore = getModule(ReceiptPickingListModule);